export const urls = {
  storefrontCollection: (slug: string) =>
    `/api/client/v1/catalog/brands/${encodeURIComponent(slug)}/`,
};

export const keys = {
  all: () => ["product-collections"],
  detail: (slug: string) => [...keys.all(), "detail", slug],
};
